import { FormattedMessage, useIntl } from 'react-intl';

import type { TooltipDatesForPartialData, TooltipProps } from '@/features/dashboard/types';
import { formatDateLocalized } from '@/lib/utils';

export const ChartTooltipFormatedDate = ({ payload, dateFormat, timeFrame, isClusteredByMonth }: TooltipProps) => {
    const { locale } = useIntl();
    const date = payload?.[0]?.payload?.date;

    if (!date) {
        return null;
    }

    if (!isClusteredByMonth) {
        return formatDateLocalized(new Date(date), locale, false, dateFormat);
    }

    const showPartialDataInStartMonth = (
        currentDataMonth: number,
        currentDataYear: number
    ): TooltipDatesForPartialData | null => {
        const { startDate } = timeFrame!;
        const isFirstMonth = currentDataMonth === startDate?.getMonth() && currentDataYear === startDate?.getFullYear();
        const isStartDateInTheFirstDay = startDate?.getDate() === 1;
        if (isFirstMonth && !isStartDateInTheFirstDay) {
            return {
                startDate: startDate,
                endDate: new Date(startDate?.getFullYear() ?? 0, (startDate?.getMonth() ?? 0) + 1, 0),
            };
        }
        return null;
    };

    const showPartialDataInEndMonth = (
        currentDataMonth: number,
        currentDataYear: number
    ): TooltipDatesForPartialData | null => {
        const { endDate } = timeFrame!;
        const isLastMonth = currentDataMonth === endDate?.getMonth() && currentDataYear === endDate?.getFullYear();
        const lastDayOfEndMonth = new Date(endDate?.getFullYear() ?? 0, (endDate?.getMonth() ?? 0) + 1, 0).getDate();
        const isEndDateInTheLastDay = endDate?.getDate() === lastDayOfEndMonth;
        if (isLastMonth && !isEndDateInTheLastDay) {
            return {
                startDate: new Date(endDate?.getFullYear() ?? 0, endDate?.getMonth() ?? 0, 1),
                endDate: endDate,
            };
        }
        return null;
    };

    const currentDataMonth = new Date(date).getMonth();
    const currentDataYear = new Date(date).getFullYear();
    const datesForPartialData =
        showPartialDataInStartMonth(currentDataMonth, currentDataYear) ||
        showPartialDataInEndMonth(currentDataMonth, currentDataYear);
    if (datesForPartialData != null) {
        return (
            <>
                <span>
                    {formatDateLocalized(new Date(datesForPartialData.startDate), locale, false, 'dd MMMM')} -{' '}
                    {formatDateLocalized(new Date(datesForPartialData.endDate), locale, false, 'dd MMMM yyyy')}
                </span>
                <div className='padding-top-5 text-color-warning'>
                    <span className='rioglyph rioglyph-warning-sign' />
                    <span className='padding-right-5 text-size-14'>
                        <FormattedMessage id='general.tooltip.partialData' />
                    </span>
                </div>
            </>
        );
    }
    return formatDateLocalized(new Date(date), locale, false, dateFormat);
};
